export { LegalPage as default } from '@/components/pages/Legal'
